var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSystemOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#72383D;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-765 -9)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(765 9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.661,11.994a6.439,6.439,0,0,0,.055-.856,5.258,5.258,0,0,0-.064-.856L19.5,8.845a.447.447,0,0,0,.109-.555L17.861,5.267a.445.445,0,0,0-.537-.2l-2.176.874a6.43,6.43,0,0,0-1.475-.856l-.328-2.312A.44.44,0,0,0,12.91,2.4h-3.5a.431.431,0,0,0-.428.373L8.659,5.085a6.572,6.572,0,0,0-1.475.856L5.009,5.067a.435.435,0,0,0-.537.2L2.733,8.289a.414.414,0,0,0,.109.555L4.69,10.283a5.064,5.064,0,0,0-.018,1.711L2.824,13.432a.447.447,0,0,0-.109.555L4.462,17.01a.445.445,0,0,0,.537.2l2.176-.874a6.43,6.43,0,0,0,1.475.856L8.977,19.5a.447.447,0,0,0,.437.373h3.5a.425.425,0,0,0,.428-.373l.328-2.312a6.243,6.243,0,0,0,1.475-.856l2.176.874a.435.435,0,0,0,.537-.2L19.6,13.988a.421.421,0,0,0-.109-.555Zm-6.5,2.421a3.277,3.277,0,1,1,3.277-3.277A3.287,3.287,0,0,1,11.162,14.415Z",
    transform: "translate(762.838 6.862)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSystemOn);
export default __webpack_public_path__ + "static/media/icon_system_on.fa14d543b0d2c48de589b618ecaa919c.svg";
export { ForwardRef as ReactComponent };